import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
Vue.use(VueExcelEditor);

export default {
  mixins: [mixx],
  name: 'cuponesLiquidados',
  data() {
    return {
      loading: false,
      archivos: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate()
      }
    }
  },
  unmounted() {
    this.tbv.destroy();
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    this.getArchivos();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },

  methods: {
    getArchivos() {
      this.loading = true;
      this.$http
        .get(
          "/natura/creation/reprocesar/archivos", { params: this.f_c }
        )
        .then(response => {
          this.loading = false;
          this.archivos = response.data;
        }).catch(error => {
          this.loading = false;
        });
    },
    procesar() {
      this.loading = true;
      this.$http
        .post(
          "/natura/creation/reprocesar", { "archivos": this.archivos.filter(a => a.selecionado).map(a => a.archivo) }
        )
        .then(response => {
          this.loading = false;
          alert("Se reprocesaron: " + response.data.procesados + " archivos");
        }).catch(error => {
          this.loading = false;
        });
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/reportes/naturaCreationReprocesar/index.js